<div id="multiple-bar-gadget" class="px-5 py-3" [ngClass]="!print ? 'download-hide' : 'd-print-block'">
  <check-to-print (notify)="onPrintNotify()" [key]="'mbg'"></check-to-print>
  @if (title) {
    <h3 translate>{{title}}</h3>
  }
  @if (dataCount) {
    <h5>{{dataCount}} <span translate>Answers</span></h5>
  }
  @if (data && data['statistics_info'] && data['statistics_info']['statistics']) {
    <div class="my-4">
      @for (bar of data.statistics_info.codesc; track bar; let index = $index) {
        <div class="row my-2">
          <div class="val col-2" translate>{{bar.additional_value}}</div>
          <div class=" col-9">
            <div class="progress">
              <!--<pre>{{data.statistics_info.statistics[1].count | json}}</pre>-->
              @if (data.statistics_info.statistics[index +1]) {
                <div id="progress-bar-{{index + 1}}" class="progress-bar " role="progressbar" [ngStyle]="setStyle(data.statistics_info.statistics[index+1].count)" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                  @if (data.statistics_info.statistics[index +1].count/dataCount*100 > 1) {
                    {{data.statistics_info.statistics[index +1].count/dataCount*100 | number : '1.0-0'}}%
                  } @else {
                    1%
                  }
                </div>
              } @else {
                <div id="progress-bar-{{index + 1}}" class="progress-bar " role="progressbar" style="width: 0;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                  0%
                </div>
              }
            </div>
          </div>
          @if (data.statistics_info.statistics[index +1]) {
            <div class="col-1 count" translate>{{data.statistics_info.statistics[index+1].count}}</div>
          } @else {
            <div class="col-1 count" translate>0</div>
          }
        </div>
      }
    </div>
  } @else {
    @if (data && data[filters.value]) {
      <div id="multipleBarWithImage" class="row">
        <div class="col-8">
          @for (bar of data[filters.value].value; track bar; let index = $index) {
            <div class="row my-2" [hidden]="index >= 16 && !open">
              <div class="val col-2" translate>{{bar[1]}}</div>
              <div class=" col-8">
                <div class="progress">
                  @if (bar[2]) {
                    <div id="progress-bar-{{index + 1}}" class="progress-bar " role="progressbar" [ngStyle]="setStyle(bar[2])" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      @if (bar[2]/dataCount*100 > 1) {
                        {{bar[2]/dataCount*100 | number : '1.0-0'}}%
                      } @else {
                        1%
                      }
                    </div>
                  } @else {
                    <div id="progress-bar-{{index + 1}}" class="progress-bar " role="progressbar" style="width: 0;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      0%
                    </div>
                  }
                </div>
              </div>
              <div class="col-1">{{bar[2]}}</div>
            </div>
          }
          <div class="show_more_less">
            @if (!open && data[filters.value].value.length > 16) {
              <div type="button" class="" (click)="open=true" translate>Show More</div>
            }
            @if (open) {
              <div type="button" class=" " (click)="open=false" translate>Show Less</div>
            }
          </div>
        </div>
        <div class="col-4 image">
        </div>
      </div>
    } @else {
      @if (!loader) {
        NO DATA
      } @else {
        <contentloader></contentloader>
      }
    }
  }
</div>





